<template>
  <a-row :gutter="20">
    <a-col :span="isDesktop ? 12 : 24">
      <a-card :title="$t('cardTitle.bulletinInserts')" class="style3">
        <p v-text="$t('page.bulletinInserts.bulletinInserts.para1')"></p>
        <button type="button" class="btn btn-info btn-lg">
          <a href="https://truelifeorg.s3.amazonaws.com/bulletin-inserts/Bulletin-Inserts.zip" style="color: #fff;">{{ $t('page.bulletinInserts.bulletinInserts.link') }}</a>
        </button>
        <p></p>

        <p>{{ $t('page.bulletinInserts.bulletinInserts.para2') }}:</p>
        <p>
          <a href="https://truelifeorg.s3.amazonaws.com/bulletin-inserts/Bulletin-Inserts.zip">
            <img src="https://truelifeorg.s3.amazonaws.com/images/truebulletininserts.png" />
          </a>
        </p>
        <!--<p><img src="https://truelifeorg.s3.amazonaws.com/bulletin-inserts/Invite+Bulliten++Long.jpg" /></p>
        <p><img src="https://truelifeorg.s3.amazonaws.com/bulletin-inserts/Invite+Bulliten++Thin+Simple+2.jpg" /></p>-->
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
};
</script>
